import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';


class PetshopAdminDashboard extends Component {
    constructor(props) {
        super(props);
      }

  render() {
    return (
        <div className="m-grid m-grid--hor m-grid--root m-page" style={{ minHeight: '100vh'}}>
            <div className="m-grid__item m-grid__item--fluid m-grid m-grid--hor-desktop m-grid--desktop m-body body-background">
                <div className="m-grid__item m-grid__item--fluid  m-grid m-grid--ver	m-container m-container--responsive m-container--xxl m-page__container">
                    <div className="m-grid__item m-grid__item--fluid m-wrapper">
                    <div className="row">
                            <div className="col-xl-4">
								<div className="m-portlet m-portlet--bordered-semi m-portlet--widget-fit m-portlet--full-height m-portlet--skin-light  m-portlet--rounded-force">
									<div className="m-portlet__head">
										<div className="m-portlet__head-caption">
											<div className="m-portlet__head-title">
												<h3 className="m-portlet__head-text">
													Activity
												</h3>
											</div>
										</div>
									</div>
									<div className="m-portlet__body">
										<div className="m-widget17">
											<div className="m-widget17__visual m-widget17__visual--chart m-portlet-fit--top m-portlet-fit--sides" style={{backgroundColor: '#f4f7fa'}}>
												<div className="m-widget17__chart" style={{height:'320px'}}><div className="chartjs-size-monitor" style={{position: 'absolute', left: '0px', top: '0px', right: '0px', bottom: '0px', overflow: 'hidden', pointerEvents: 'none', visibility: 'hidden', zIndex: '-1'}}><div className="chartjs-size-monitor-expand" style={{position:'absolute', left:'0', top:'0', right:'0', bottom:'0', overflow:'hidden', pointerEvents:'none', visibility:'hidden',zIndex:'-1'}}><div style={{position:'absolute',width:'1000000px',height:'1000000px',left:'0',top:'0'}}></div></div><div className="chartjs-size-monitor-shrink" style={{position:'absolute',left:'0',top:'0',right:'0',bottom:'0',overflow:'hidden',pointerEvents:'none',visibility:'hidden',zIndex:'-1'}}><div style={{position:'absolute',width:'200%',height:'200%',left:'0',top:'0'}}></div></div></div>
													<canvas id="m_chart_activities" width='509' height='216' className="chartjs-render-monitor" style={{display: 'block', width: '509px', height: '216px'}}></canvas>
												</div>
											</div>
											<div className="m-widget17__stats">
												<div className="m-widget17__items m-widget17__items-col1">
													<div className="m-widget17__item">
														<span className="m-widget17__icon">
															<i className="fas fa-store m--font-brand" style={{fontSize:'4rem'}}></i>
														</span>
														<span className="m-widget17__subtitle">
                                                            Pet Shops
														</span>
														<span className="m-widget17__desc">
															15 Pet Shops
														</span>
													</div>
												</div>
                                                <div className="m-widget17__items m-widget17__items-col2">
                                                    <div className="m-widget17__item">
														<span className="m-widget17__icon">
															<i className="fas fa-user-tie m--font-success" style={{fontSize:'4rem'}}></i>
														</span>
														<span className="m-widget17__subtitle">
															Users
														</span>
														<span className="m-widget17__desc">
															72 New Users
														</span>
													</div> 
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
                            <div className="col-xl-4">
								<div className="m-portlet m-portlet--bordered-semi m-portlet--full-height">
									<div className="m-portlet__head">
										<div className="m-portlet__head-caption">
											<div className="m-portlet__head-title">
												<h3 className="m-portlet__head-text">
													Sales Status
												</h3>
											</div>
										</div>
									</div>
									<div className="m-portlet__body">
										<div className="m-widget29">
                                            <div className="m-widget1__item">
                                                <div className="m-widget_content">
                                                    <h3 className="m-widget_content-title">You have Earned</h3>
                                                    <div className="m-widget_content-items">
                                                        <div className="m-widget_content-item">
                                                            <span>Total</span>
                                                            <span className="m--font-accent">$680</span>
                                                        </div>
                                                        <div className="m-widget_content-item">
                                                            <span>Change</span>
                                                            <span className="m--font-brand">+15%</span>
                                                        </div>
                                                        <div className="m-widget_content-item">
                                                            <span>Licenses</span>
                                                            <span>29</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="m-widget1__item">
                                                <div className="m-widget_content">
                                                    <h3 className="m-widget_content-title">Today</h3>
                                                    <div className="m-widget_content-items">
                                                        <div className="m-widget_content-item">
                                                            <span>Total</span>
                                                            <span className="m--font-accent">22.50</span>
                                                        </div>
                                                        <div className="m-widget_content-item">
                                                            <span>Change</span>
                                                            <span className="m--font-brand">+15%</span>
                                                        </div>
                                                        <div className="m-widget_content-item">
                                                            <span>Count</span>
                                                            <span>701</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
											<div className="m-widget_content">
												<h3 className="m-widget_content-title">This Month</h3>
												<div className="m-widget_content-items">
													<div className="m-widget_content-item">
														<span>Total</span>
														<span className="m--font-accent">$680</span>
													</div>
													<div className="m-widget_content-item">
														<span>Change</span>
														<span className="m--font-brand">+15%</span>
													</div>
													<div className="m-widget_content-item">
														<span>Licenses</span>
														<span>29</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
                            <div className="col-xl-4">							
                                <div className="m-portlet m-portlet--full-height">
                                    <div className="m-portlet__head">
                                        <div className="m-portlet__head-caption">
                                            <div className="m-portlet__head-title">
                                                <h3 className="m-portlet__head-text">
                                                    Recent Notifications
                                                </h3>
                                            </div>
                                        </div>
                                        <div className="m-portlet__head-tools">
                                            <ul className="nav nav-pills nav-pills--brand m-nav-pills--align-right m-nav-pills--btn-pill m-nav-pills--btn-sm" role="tablist">
                                                <li className="nav-item m-tabs__item">
                                                    <a className="nav-link m-tabs__link active show" data-toggle="tab" href="#m_widget2_tab1_content" role="tab" aria-selected="true">
                                                        Today
                                                    </a>
                                                </li>
                                                <li className="nav-item m-tabs__item">
                                                    <a className="nav-link m-tabs__link" data-toggle="tab" href="#m_widget2_tab2_content" role="tab" aria-selected="false">
                                                        Month
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                        <div className="m-portlet__body">
                            <div className="tab-content">
                                <div className="tab-pane active" id="m_widget2_tab1_content">
                                    <div className="m-timeline-3">
                                        <div className="m-timeline-3__items">
                                            <div className="m-timeline-3__item m-timeline-3__item--info">
                                                <span className="m-timeline-3__item-time">09:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Lorem ipsum dolor sit amit,consectetur eiusmdd tempor
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By Bob
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--warning">
                                                <span className="m-timeline-3__item-time">10:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Lorem ipsum dolor sit amit
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By Sean
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--brand">
                                                <span className="m-timeline-3__item-time">11:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Lorem ipsum dolor sit amit eiusmdd tempor
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By James
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--success">
                                                <span className="m-timeline-3__item-time">12:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Lorem ipsum dolor
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By James
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--danger">
                                                <span className="m-timeline-3__item-time">14:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Lorem ipsum dolor sit amit,consectetur eiusmdd
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By Derrick
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--info">
                                                <span className="m-timeline-3__item-time">15:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Lorem ipsum dolor sit amit,consectetur
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By Iman
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--brand">
                                                <span className="m-timeline-3__item-time">17:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Lorem ipsum dolor sit consectetur eiusmdd tempor
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By Aziko
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>  
                                </div>
                                <div className="tab-pane" id="m_widget2_tab2_content">
                                    <div className="m-timeline-3">
                                        <div className="m-timeline-3__items">
                                            <div className="m-timeline-3__item m-timeline-3__item--info">
                                                <span className="m-timeline-3__item-time m--font-focus">09:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Contrary to popular belief, Lorem Ipsum is not simply random text.
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By Bob
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--warning">
                                                <span className="m-timeline-3__item-time m--font-warning">10:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        There are many variations of passages of Lorem Ipsum available.
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By Sean
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--brand">
                                                <span className="m-timeline-3__item-time m--font-primary">11:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Contrary to popular belief, Lorem Ipsum is not simply random text.
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By James
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--success">
                                                <span className="m-timeline-3__item-time m--font-success">12:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        The standard chunk of Lorem Ipsum used since the 1500s is reproduced.
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By James
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--danger">
                                                <span className="m-timeline-3__item-time m--font-warning">14:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Latin words, combined with a handful of model sentence structures.
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By Derrick
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--info">
                                                <span className="m-timeline-3__item-time m--font-info">15:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Contrary to popular belief, Lorem Ipsum is not simply random text.
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By Iman
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className="m-timeline-3__item m-timeline-3__item--brand">
                                                <span className="m-timeline-3__item-time m--font-danger">17:00</span>
                                                <div className="m-timeline-3__item-desc">
                                                    <span className="m-timeline-3__item-text">
                                                        Lorem Ipsum is therefore always free from repetition, injected humour.
                                                    </span>
                                                    <br/>
                                                    <span className="m-timeline-3__item-user-name">
                                                        <a href="#" className="m-link m-link--metal m-timeline-3__item-link">
                                                            By Aziko
                                                        </a>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
                        <div className="row">
                        <div className="col-xl-4">
								<div className="m-portlet m-portlet--head-overlay m-portlet--full-height   m-portlet--rounded-force">
									<div className="m-portlet__head m-portlet__head--fit">
										<div className="m-portlet__head-caption">
											<div className="m-portlet__head-title">
												<h3 className="m-portlet__head-text m--font-light">
                                                    Treatments
												</h3>
											</div>
										</div>
									</div>
									<div className="m-portlet__body">
										<div className="m-widget28">
											<div className="m-widget28__pic m-portlet-fit--sides"><img src="assets/app/media/img/pets/pupBg.jpg" alt=""/></div>
											<div className="m-widget28__container">
												<ul className="m-widget28__nav-items nav nav-pills nav-fill" role="tablist">
													<li className="m-widget28__nav-item nav-item">
														<a className="nav-link active show" data-toggle="pill" href="#menu11">
															<span>
																<i className="fas fa-syringe" style={{paddingBottom:'2rem',paddingTop:'1.4rem'}}></i>
															</span>
															<span>On going Treatments</span>
														</a>
													</li>
													{/* <li className="m-widget28__nav-item nav-item">
														<a className="nav-link" data-toggle="pill" href="#menu21">
															<span>
																<i className="fa flaticon-file-1"></i>
															</span>
															<span>IMT Invoice</span>
														</a>
													</li> */}
													<li className="m-widget28__nav-item nav-item">
														<a className="nav-link" data-toggle="pill" href="#menu31">
															<span>
																<i className="fas fa-syringe" style={{paddingBottom:'2rem',paddingTop:'1.4rem'}}></i>
															</span>
															<span>Pending Treatments</span>
														</a>
													</li>
												</ul>
												<div className="m-widget28__tab tab-content">
													<div id="menu11" className="m-widget28__tab-container tab-pane active show">
														<div className="m-widget28__tab-items">
															<div className="m-widget28__tab-item">
																<span>Company Name</span>
																<span>SLT Back-end Solutions</span>
															</div>
															<div className="m-widget28__tab-item">
																<span>INE Number</span>
																<span>D330-1234562546</span>
															</div>
															<div className="m-widget28__tab-item">
																<span>Total Charges</span>
																<span>USD 1,250.000</span>
															</div>
															<div className="m-widget28__tab-item">
																<span>Project Description</span>
																<span>Creating Back-end Components</span>
															</div>
														</div>
													</div>
													<div id="menu21" className="m-widget28__tab-container tab-pane fade">
														<div className="m-widget28__tab-items">
															<div className="m-widget28__tab-item">
																<span>Project Description</span>
																<span>Back-End Web Architecture</span>
															</div>
															<div className="m-widget28__tab-item">
																<span>Total Charges</span>
																<span>USD 2,170.000</span>
															</div>
															<div className="m-widget28__tab-item">
																<span>INE Number</span>
																<span>D110-1234562546</span>
															</div>
															<div className="m-widget28__tab-item">
																<span>Company Name</span>
																<span>SLT Back-end Solutions</span>
															</div>
														</div>
													</div>
													<div id="menu31" className="m-widget28__tab-container tab-pane fade">
														<div className="m-widget28__tab-items">
															<div className="m-widget28__tab-item">
																<span>Total Charges</span>
																<span>USD 3,450.000</span>
															</div>
															<div className="m-widget28__tab-item">
																<span>Project Description</span>
																<span>Creating Back-end Components</span>
															</div>
															<div className="m-widget28__tab-item">
																<span>Company Name</span>
																<span>SLT Back-end Solutions</span>
															</div>
															<div className="m-widget28__tab-item">
																<span>INE Number</span>
																<span>D510-7431562548</span>
															</div>
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
                        <div className="col-xl-4">
                                <div className="m-portlet m-portlet--full-height ">
                                        <div className="m-portlet__head">
                                            <div className="m-portlet__head-caption">
                                                <div className="m-portlet__head-title">
                                                    <h3 className="m-portlet__head-text">
                                                        Recent Contracts
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    <div className="m-portlet__body">
                                        <div className="m-widget3">
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className="m-widget3__item">
                                                        <div className="m-widget3__header">
                                                            <div className="m-widget3__user-img">
                                                                <img className="m-widget3__img" src="assets/app/media/img/pets/pup04.jpg" alt=""/>
                                                            </div>
                                                            <div className="m-widget3__info pb-2">
                                                                <span className="m-widget3__username">
                                                                    Ranidu Nadeesha
                                                                </span>
                                                                <br/>
                                                                <span className="m-badge m-badge--info px-2">Pet Id. <strong>14789</strong></span>
                                                                <br/>
                                                                <span className="m-widget3__time">
                                                                    2018-06-04
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="m-widget3__item">
                                                        <div className="m-widget3__header">
                                                            <div className="m-widget3__user-img">
                                                                <img className="m-widget3__img" src="assets/app/media/img/pets/pup01.jpg" alt=""/>
                                                            </div>
                                                            <div className="m-widget3__info pb-2">
                                                                <span className="m-widget3__username">
                                                                    Ranidu Nadeesha
                                                                </span>
                                                                <br/>
                                                                <span className="m-badge m-badge--info px-2">Pet Id. <strong>14789</strong></span>
                                                                <br/>
                                                                <span className="m-widget3__time">
                                                                    2018-06-04
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="m-widget3__item">
                                                        <div className="m-widget3__header">
                                                            <div className="m-widget3__user-img">
                                                                <img className="m-widget3__img" src="assets/app/media/img/pets/pup02.jpg" alt=""/>
                                                            </div>
                                                            <div className="m-widget3__info pb-2">
                                                                <span className="m-widget3__username">
                                                                    Ranidu Nadeesha
                                                                </span>
                                                                <br/>
                                                                <span className="m-badge m-badge--info px-2">Pet Id. <strong>14789</strong></span>
                                                                <br/>
                                                                <span className="m-widget3__time">
                                                                    2018-06-04
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="m-widget3__item">
                                                        <div className="m-widget3__header">
                                                            <div className="m-widget3__user-img">
                                                                <img className="m-widget3__img" src="assets/app/media/img/pets/pup05.jpg" alt=""/>
                                                            </div>
                                                            <div className="m-widget3__info pb-2">
                                                                <span className="m-widget3__username">
                                                                    Ranidu Nadeesha
                                                                </span>
                                                                <br/>
                                                                <span className="m-badge m-badge--info px-2">Pet Id. <strong>14789</strong></span>
                                                                <br/>
                                                                <span className="m-widget3__time">
                                                                    2018-06-04
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="m-widget3__item">
                                                        <div className="m-widget3__header">
                                                            <div className="m-widget3__user-img">
                                                                <img className="m-widget3__img" src="assets/app/media/img/pets/pup05.jpg" alt=""/>
                                                            </div>
                                                            <div className="m-widget3__info pb-2">
                                                                <span className="m-widget3__username">
                                                                    Ranidu Nadeesha
                                                                </span>
                                                                <br/>
                                                                <span className="m-badge m-badge--info px-2">Pet Id. <strong>14789</strong></span>
                                                                <br/>
                                                                <span className="m-widget3__time">
                                                                    2018-06-04
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-4">
                                <div className="m-portlet m-portlet--full-height ">
                                        <div className="m-portlet__head">
                                            <div className="m-portlet__head-caption">
                                                <div className="m-portlet__head-title">
                                                    <h3 className="m-portlet__head-text">
                                                        Recent Puppy Records
                                                    </h3>
                                                </div>
                                            </div>
                                        </div>
                                    <div className="m-portlet__body">
                                        <div className="m-widget3">
                                            <div className="row">
                                                <div className="col-xl-12">
                                                    <div className="m-widget3__item">
                                                        <div className="m-widget3__header">
                                                            <div className="m-widget3__user-img">
                                                                <img className="m-widget3__img" src="assets/app/media/img/pets/pup04.jpg" alt=""/>
                                                            </div>
                                                            <div className="m-widget3__info pb-2">
                                                                <span className="m-badge m-badge--info px-2">Pet Id. <strong>14789</strong></span>
                                                                <br/>
                                                                <p className="m-widget3__text mb-0">
                                                                    <strong>Breed:</strong> Alsation
                                                                </p>
                                                                <span className="m-widget3__time">
                                                                    2 day ago
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="m-widget3__item">
                                                        <div className="m-widget3__header">
                                                            <div className="m-widget3__user-img">
                                                                <img className="m-widget3__img" src="assets/app/media/img/pets/pup01.jpg" alt=""/>
                                                            </div>
                                                            <div className="m-widget3__info pb-2">
                                                                <span className="m-badge m-badge--info px-2">Pet Id. <strong>14789</strong></span>
                                                                <br/>
                                                                <p className="m-widget3__text mb-0">
                                                                    <strong>Breed:</strong> Alsation
                                                                </p>
                                                                <span className="m-widget3__time">
                                                                    1 day ago
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="m-widget3__item">
                                                        <div className="m-widget3__header">
                                                            <div className="m-widget3__user-img">
                                                                <img className="m-widget3__img" src="assets/app/media/img/pets/pup02.jpg" alt=""/>
                                                            </div>
                                                            <div className="m-widget3__info pb-2">
                                                                <span className="m-badge m-badge--info px-2">Pet Id. <strong>14789</strong></span>
                                                                <br/>
                                                                <p className="m-widget3__text mb-0">
                                                                    <strong>Breed:</strong> Alsation
                                                                </p>
                                                                <span className="m-widget3__time">
                                                                    3 weeks ago
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="m-widget3__item">
                                                        <div className="m-widget3__header">
                                                            <div className="m-widget3__user-img">
                                                                <img className="m-widget3__img" src="assets/app/media/img/pets/pup05.jpg" alt=""/>
                                                            </div>
                                                            <div className="m-widget3__info pb-2">
                                                                <span className="m-badge m-badge--info px-2">Pet Id. <strong>14789</strong></span>
                                                                <br/>
                                                                <p className="m-widget3__text mb-0">
                                                                    <strong>Breed:</strong> Alsation
                                                                </p>
                                                                <span className="m-widget3__time">
                                                                    1 day ago
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="m-widget3__item">
                                                        <div className="m-widget3__header">
                                                            <div className="m-widget3__user-img">
                                                                <img className="m-widget3__img" src="assets/app/media/img/pets/pup05.jpg" alt=""/>
                                                            </div>
                                                            <div className="m-widget3__info pb-2">
                                                                <span className="m-badge m-badge--info px-2">Pet Id. <strong>14789</strong></span>
                                                                <br/>
                                                                <p className="m-widget3__text mb-0">
                                                                    <strong>Breed:</strong> Alsation
                                                                </p>
                                                                <span className="m-widget3__time">
                                                                    1 day ago
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
						</div>
                    </div>
                </div>
            </div>
        </div>

    )
  }
}

const mapStateToProps = state => ({
  user: state.cognito.user,
});


export default withRouter(connect(mapStateToProps)(PetshopAdminDashboard));
